import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';

let initialized = false;

export async function initFirebase(): Promise<void> {
  if (initialized) return;
  try {
    await FirebaseCrashlytics.setEnabled({ enabled: true });
    initialized = true;
  } catch {
    // Web環境では無視
  }
}

export async function logEvent(name: string, params?: Record<string, string | number | boolean>): Promise<void> {
  try {
    await FirebaseAnalytics.logEvent({ name, params });
  } catch (error) {
    // Web環境やネイティブ未初期化時は無視、それ以外は警告ログ
    if (error instanceof Error && !error.message.includes('not implemented')) {
      console.warn(`[Firebase] logEvent failed: ${name}`, error);
    }
  }
}

export async function logBattleStart(mode: string, monsterName: string): Promise<void> {
  await logEvent('battle_start', { mode, monster_name: monsterName });
}

export async function logBattleEnd(mode: string, result: string, turns: number): Promise<void> {
  await logEvent('battle_end', { mode, result, turns });
}

export async function logModeSelect(mode: string): Promise<void> {
  await logEvent('mode_select', { mode });
}

export async function logCharacterSelect(monsterName: string): Promise<void> {
  await logEvent('character_select', { monster_name: monsterName });
}
